import script from "./AllCustomers.vue?vue&type=script&setup=true&lang=js"
export * from "./AllCustomers.vue?vue&type=script&setup=true&lang=js"

import "./AllCustomers.vue?vue&type=style&index=0&id=c54199c0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c54199c0"]])

export default __exports__